import { render, staticRenderFns } from "./users-management.vue?vue&type=template&id=980b0bba"
import script from "./users-management.vue?vue&type=script&lang=js"
export * from "./users-management.vue?vue&type=script&lang=js"
import style0 from "./users-management.vue?vue&type=style&index=0&id=980b0bba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports